import { cord, formatInput, gql2 } from "@/gql/lib";
import {
  TimeAxisRangeInput,
  QueryTier1countArgs,
  AxisType,
  ActionEnum,
} from "@/gql/types";

const q = (
  frame: TimeAxisRangeInput,
  labels: string[]
): QueryTier1countArgs => {
  return {
    params: {
      coordinate: {
        x: cord(AxisType.None),
        y: {
          type: AxisType.ContentLabel,
          values: labels,
        },
        z: frame,
      },
      pageSize: 1000,
      cursor: "",
      action: ActionEnum.List,
    },
  };
};

//export const get_labels_count = gql2<InformationType[]>
export const get_all_piis = gql2<string[], any>(
  "mapping-tier1.all_pii_labels_count",
  (labels, { frame }) => {
    return {
      query: `
        {
            tier1count(params:${formatInput(q(frame, labels).params)}){
              y{value}
              count
            }
        }
        `,
      mapper: (res) => {
        return res.tier1count;
      },
    };
  }
);
